
import { Component, Vue } from 'vue-property-decorator';

import Form11ProcessHeader from "@/components/process/Form11/components/Form11ProcessHeader.vue";
import Form11StyleOfProceeding from "@/components/process/Form11/components/Form11StyleOfProceeding.vue";
import { form11StatusInfoType } from '@/types/Information/Form11';

@Component({
    components:{
        Form11ProcessHeader,        
        Form11StyleOfProceeding
    }
})
export default class FillForm11 extends Vue {

    stepsCompleted = {} as form11StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: false,
            second: false,
            third: false
        }       
    }
}
